/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning prerequisite type values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_PREREQUISITE_TYPES } from '@shared/constants';
 * 
 * if (prerequisite.type === LEARNING_PREREQUISITE_TYPES.BLOCKING) {
 *   // Handle blocking prerequisite
 * }
 * ```
 */
export const LEARNING_PREREQUISITE_TYPES = {
  BLOCKING: 'blocking',
  RECOMMENDED: 'recommended'
} as const; 